const adBreakpoints = [
  { 'minWidth': 320, 'name': 'mobile' },
  { 'minWidth': 768, 'name': 'tablet' },
  { 'minWidth': 1024, 'name': 'desktop' }
]

const getDeviceConfig = (width) => {
  let i
  for (i = adBreakpoints.length - 1; i >= 0; i--) {
    if (width >= adBreakpoints[i].minWidth) {
      return adBreakpoints[i].name
    }
  }
  return 'mobile'
}

const device = getDeviceConfig(global.innerWidth)

export default device
